'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWarningScreenMessage = exports.setInformationalScreenMessage = exports.setSuccessfulScreenMessage = exports.setErrorScreenMessage = undefined;

var _ScreenKeyConst = require('../../../components/screen/ScreenKeyConst');

var _Notification = require('../../../managewidgets/components/notification/Notification');

var _ScreenReducer = require('../../../components/screen/ScreenReducer');

var _Store = require('../../../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _ScreenMessageActionCreators = require('../../../components/screenmessage/actions/ScreenMessageActionCreators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScreenMessageErrors = function getScreenMessageErrors(errors) {
  if (errors && errors.length > 0) {
    return errors.map(function (error) {
      return {
        value: error,
        isError: true,
        isHTML: false
      };
    });
  }

  return [];
};

var setScreenMessage = function setScreenMessage(type, text, isHTML, subMessages, screenKey, typesToClear) {

  var screenMessage = {
    type: type,
    message: {
      value: text,
      isHTML: isHTML
    },
    subMessages: subMessages
  };

  var state = (0, _Store2.default)().getState();
  var screenMessages = (0, _ScreenReducer.getScreenMessages)(state.screen, screenKey);
  screenMessages = screenMessages ? screenMessages.toJS() : [];

  if (typesToClear) {
    screenMessages = screenMessages.filter(function (item) {
      return typesToClear.indexOf(item.type) === -1;
    });
  }

  var index = screenMessages.findIndex(function (item) {
    return item.message.value === screenMessage.message.value && item.type === screenMessage.type;
  });

  if (index === -1) {
    screenMessages.push(screenMessage);
  }

  return (0, _ScreenMessageActionCreators.setScreenMessageAction)(screenMessages, screenKey);
};

var setErrorScreenMessage = exports.setErrorScreenMessage = function setErrorScreenMessage(text, isHTML, errors) {
  var screenKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;
  var clearExistingMessages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;


  var subMessages = getScreenMessageErrors(errors);

  var typesToClear = clearExistingMessages ? [_Notification.NotificationStatus.ERROR, _Notification.NotificationStatus.SUCCESSFUL] : [];

  return setScreenMessage(_Notification.NotificationStatus.ERROR, text, isHTML, subMessages, screenKey, typesToClear);
};

var setSuccessfulScreenMessage = exports.setSuccessfulScreenMessage = function setSuccessfulScreenMessage(text, isHTML, subMessages) {
  var screenKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;
  var clearExistingMessages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;


  var typesToClear = clearExistingMessages ? [_Notification.NotificationStatus.SUCCESSFUL, _Notification.NotificationStatus.ERROR] : [];

  return setScreenMessage(_Notification.NotificationStatus.SUCCESSFUL, text, isHTML, subMessages, screenKey, typesToClear);
};

var setInformationalScreenMessage = exports.setInformationalScreenMessage = function setInformationalScreenMessage(text, isHTML, subMessages) {
  var screenKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;
  var clearExistingMessages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;


  var typesToClear = clearExistingMessages ? [_Notification.NotificationStatus.INFORMATIONAL] : [];

  return setScreenMessage(_Notification.NotificationStatus.INFORMATIONAL, text, isHTML, subMessages, screenKey, typesToClear);
};

var setWarningScreenMessage = exports.setWarningScreenMessage = function setWarningScreenMessage(text, isHTML, subMessages) {
  var screenKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;
  var clearExistingMessages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;


  var typesToClear = clearExistingMessages ? [_Notification.NotificationStatus.WARNING] : [];

  return setScreenMessage(_Notification.NotificationStatus.WARNING, text, isHTML, subMessages, screenKey, typesToClear);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screenmessage/actions/SetScreenMessageAction.js
// module id = 761
// module chunks = 10